module.exports = __webpack_public_path__ + "img/1-web.339fc6ce.jpg";